/** @format */

import { getDicts, getTypeList, listData } from './data';

/**
 * 获取字典数据
 */
export function useDict(...args) {
	const res = ref({});
	return (() => {
		args.forEach((d) => {
			res.value[d] = [];
			getDicts(d).then((resp) => {
				res.value[d] = resp.data.map((p) => ({
					label: p.dictLabel,
					value: p.dictValue,
					elTagType: p.listClass,
					elTagClass: p.cssClass,
				}));
			});
		});
		return toRefs(res.value);
	})();
}

/**
 * 获取字典分类列表
 */
export async function useDictTypeList() {
	const res = await getTypeList({ pageNum: 1, pageSize: 100000 });
	return res.rows.map((itm) => ({ label: itm.dictName, value: itm.dictType }));
}

/**
 * 获取指定字典分类下字段列表
 */
export async function useDictList(params: {
	pageNum?: number;
	pageSize?: number;
	dictType: string;
	orderByColumn?: string;
	isAsc?: string;
}) {
	const INIT_PARAMS = {
		pageNum: 1,
		pageSize: 100000,
		orderByColumn: 'createTime',
		isAsc: 'descending',
	};

	const res = await listData({ ...INIT_PARAMS, ...params });
	return res.rows.map((itm) => ({ label: itm.dictLabel, value: itm.dictValue }));
}
